<template>
  <div class="manage-page">
    <div class="side-nav-menu">
      <!--      <el-menu mode="vertical"-->
      <!--               :default-active="$route.path"-->
      <!--               @select="handleSelect"-->
      <!--               background-color="#E9E9EA"-->
      <!--               text-color="#777"-->
      <!--               router-->
      <!--               :default-openeds="['0','1']"-->
      <!--      >-->
      <!--        <el-submenu index="0">-->
      <!--          <template slot="title">-->
      <!--            <i class="el-icon-cpu"></i>-->
      <!--            <span>排班后台</span>-->
      <!--          </template>-->
      <!--          <el-menu-item-group>-->
      <!--            <el-menu-item index="/managePage/workforceMgmt">排班管理</el-menu-item>-->
      <!--            <el-menu-item index="/managePage/peopleMgmt">人员管理</el-menu-item>-->
      <!--            <el-menu-item index="/managePage/unitMgmt">组织管理</el-menu-item>-->
      <!--          </el-menu-item-group>-->
      <!--        </el-submenu>-->
      <!--        <el-submenu index="1">-->
      <!--          <template slot="title">-->
      <!--            <i class="el-icon-first-aid-kit"></i>-->
      <!--            <span>防疫管理</span>-->
      <!--          </template>-->
      <!--          <el-menu-item-group>-->
      <!--            <el-menu-item index="/managePage/track">人员轨迹</el-menu-item>-->
      <!--          </el-menu-item-group>-->
      <!--        </el-submenu>-->
      <!--      </el-menu>-->
      <Sidebar :menuList="menuList"></Sidebar>
    </div>
    <div class="main-display-area">
      <router-view />
    </div>
  </div>
</template>

<script>
import Sidebar from "./common/SideBar";
import Utils from "../utils/utils";
export default {
  name: "managePage",
  components: { Sidebar },
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      menuList: []
    };
  },
  mounted() {
    this.getMenuList();
  },
  methods: {
    handleSelect: function(key, keyPath) {
      if (this.$route.path == key) {
        this.$nextTick(() => {
          this.$router.replace("/managePage/emptyPage");
        });
      }
    },
    getMenuList() {
      let self = this;
      this.$http
        .get("/admin/application/menu/getAvailable?platformType=3", {
          headers: { token: this.token }
        })
        .then(function(response) {
          let res = response.data;
          self.menuList = res.ldata;
        })
        .catch(function(response) {
          console.log(response);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.manage-page {
  .side-nav-menu {
    position: absolute;
    left: 0;
    width: 200px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background: #e9e9ea;
  }

  .main-display-area {
    position: absolute;
    left: 200px;
    right: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/managePage.vue